import React from 'react'
import { checkTranslation, translate } from '../../utils/useful'
// import StagesManager from '../../components/StagesManager'
// import OwnedRooms from './OwnedRooms'
// import OtherRooms from './OthersRooms'
// import RoomsInfo from './RoomsInfo'
import HttpServices from '../../utils/Http.services'
import FormViewer from '../../components/FormViewer'
import store from '../../stores/storeConfig';
import { setPage } from '../../stores/actionsList';


class NewSchedule extends React.Component {
    state = {

        headers: [
            { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}rooms.Title', placeholder: '{{lang}}rooms.Add title', required: true } },

            { key: 'startTime', type: 'DateTimeInput', col: '6', information: { label: '{{lang}}rooms.Start time', placeholder: '{{lang}}rooms.Select start time', required: true }, showMain: false },
            { key: 'endTime', type: 'DateTimeInput', col: '6', information: { label: '{{lang}}rooms.End time', placeholder: '{{lang}}rooms.Select end time' }, showMain: false },

            // { key: 'Format', type: 'CheckboxInput', col: '2', information: { label: '', required: true }, showMain: false },
            // { key: 'Format', type: 'SwitchInput', col: '10', information: { type: "local", items: [{ title: '{{lang}}rooms.Daily', },], label: '', placeholder: '{{lang}}rooms.Does not repeat', required: false } },

            // { key: 'Notification', type: 'SelectInput', col: '4', information: { type: "local", items: [{ title: '{{lang}}rooms.Email', },], label: '', placeholder: '{{lang}}rooms.Notification', required: false } },
            // { key: 'Notification', type: 'TimeInput', col: '4', information: { label: '', placeholder: '{{lang}}rooms.Does not repeat', required: false } },
            // { key: 'Notification', type: 'SelectInput', col: '4', information: { type: "local", items: [{ title: '{{lang}}rooms.hours', }, { title: '{{lang}}rooms.days', }, { title: '{{lang}}rooms.weeks', },], label: '', placeholder: '{{lang}}rooms.minutes', required: false } },

            // { key: 'url', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}rooms.URL address', placeholder: '{{lang}}rooms.your title plus the date and some other factore make an URL address', required: true } },

            { key: 'description', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}rooms.Description', placeholder: '{{lang}}Optional description', required: false } },
            { key: 'participants', type: 'GlobalUserMultiInput', col: '12', information: { label: '{{lang}}participants', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Other participants', required: false } },

        ],
    }

    componentDidMount() {

        HttpServices.request('getMyRooms', { frame: this.props.page?._id, applet: this.props.applet?._id }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ videocalls: fetchResult.info })

        })

    }


    saveSchedular = () => {
        let data = this.form.getForm()
        if (data) {

            data.schedule = true
            // data.applet = this.props.applet._id

            let scope = this.state.currentScope ?? this.props.scope
            let frame = (scope?.item?._id && scope.type == 'frame') ? this.props.page?._id : null

            // console.log(scope)
            // console.log(frame)


            data.frame = frame
            // console.log('data', data)
            // data.applet =
            HttpServices.request('createRoom', data, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                this.setState({ schedule: fetchResult.info })

                this.changePage('schedule')
                let page = [<div className='h-100 modal-body w-100 bg-white br-5 px-2 py-2'>
                    <div className='flexcc my-4'>
                        <p className=''>Do you want to add into your calendar?</p>
                    </div>
                    <div className='flexcc w-100'>
                        <div className='flexcb w-100' style={{ maxWidth: '200px' }}>
                            <button className='p-2 br-10' style={{ width: '80px', backgroundColor: '#2ca326' }} onClick={() => this.addCalendar()}>
                                <p className='text-small' style={{ color: '#fff' }}>{translate("Add")}</p>
                            </button>
                            <button className='p-2 br-5 ' style={{ width: '80px', backgroundColor: '#d30027' }} onClick={() => store.dispatch(setPage([]))}>
                                <p className='text-small' style={{ color: '#fff' }}>{translate("Cancel")}</p>
                            </button>
                        </div>
                    </div>
                </div>]
                store.dispatch(setPage(page))
                // this.scheduleModal.showModal()
            })
        }
    }


    render() {
        return (

            <div className='window-content-radius scroll-no-scrollbar h-100' stage={1} stageName={'newschedule'}>
                <div className='flexcb w-100 py-2 px-3' style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 10 }}>
                    <button className='flexcc' onClick={() => { this.props.changePage('') }}>
                        <img src='/assets/icons/rooms/cancel.svg' width={16} />
                    </button>
                    <button className=' br-30 flexcc py-2 px-4' style={{ background: 'linear-gradient(to right,#9564FE, #7064FE)', color: '#fff', transition: 'all 0.5s' }} onClick={() => { this.saveSchedular() }}>
                        <p className='' style={{ whiteSpace: 'nowrap' }}>{translate("rooms.Save")}</p>
                    </button>
                </div>
                <div className='h-100 px-1 py-2'>
                    <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"bordered-form"} inputClass={"bordered-input"} />
                </div>
            </div>

        )
    }
}

export default NewSchedule;